<div class="grid">
    <div class="col-12">
        <div class="card">
            <div class="p-fluid grid">
                <div class="col-12 md:col-2">
                    <button
                        pButton
                        pRipple
                        routerLink="/rfarias/usuario-franquia/inserir"
                        label="Novo"
                        icon="pi pi-plus"
                        class="p-button-outlined sm:w-9rem"
                    ></button>
                </div>
            </div>
            <p-table
                #dt1
                [value]="usuarios"
                dataKey="id"
                [rows]="10"
                [loading]="loading"
                [rowHover]="true"
                styleClass="p-datatable-gridlines"
                [paginator]="true"
                [globalFilterFields]="['nome', 'apelido', 'email', 'tipo']"
                responsiveLayout="scroll"
                styleClass=" p-datatable-sm"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-end flex-column sm:flex-row">
                        <div class="p-fluid flex">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input
                                    pInputText
                                    type="text"
                                    #filter
                                    (input)="buscar(dt1, $event)"
                                    placeholder="Buscar"
                                    class="w-full"
                                />
                            </span>
                            <span class="ml-2">
                                <button
                                    pButton
                                    class="p-button-outlined"
                                    icon="pi pi-filter-slash"
                                    pTooltip="Limpar Filtros"
                                    (click)="limpar(dt1)"
                                ></button>
                            </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="apelido">
                            Nome
                            <p-sortIcon field="apelido"></p-sortIcon>
                        </th>
                        <th pSortableColumn="email">
                            E-mail
                            <p-sortIcon field="email"></p-sortIcon>
                        </th>
                        <th pSortableColumn="tipo">
                            Tipo
                            <p-sortIcon field="tipo"></p-sortIcon>
                        </th>

                        <th>
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.apelido }}
                        </td>
                        <td>
                            {{ item.email }}
                        </td>
                        <td>
                            {{ item.tipo }}
                        </td>

                        <td>
                            <button
                                pButton
                                pRipple
                                pTooltip="Detalhar"
                                icon="pi pi-eye"
                                class="p-button-info mr-2 mb-2"
                                (click)="detalhar(item.id)"
                            ></button>
                            <button
                                pButton
                                pRipple
                                pTooltip="Editar"
                                icon="pi pi-pencil"
                                class="p-button-success mr-2 mb-2"
                                (click)="editar(item.id)"
                            ></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando contratos. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
